import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=79950888&scoped=true"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"
import style0 from "./FilesView.vue?vue&type=style&index=0&id=79950888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79950888",
  null
  
)

export default component.exports